import React, { useMemo } from "react";

import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";

import Maintenance from "../../components/Maintenance/Maintenance";
import { MAINTENANCE_IGNORE_IDS } from "../../utils/constants";

const MaintenanceWrapper = ({ casino = false, sportsbook = false }) => {
  const casinoShutdown = useSelector((state) => state.settings.casinoShutdown);
  const sportsbookShutdown = useSelector(
    (state) => state.settings.sportsbookShutdown
  );
  const userId = useSelector((state) => state?.authentication?.userId);
  const ignoreMaintenance = useMemo(
    () => MAINTENANCE_IGNORE_IDS?.includes(`${userId}`),
    [userId]
  );
  if (casino && casinoShutdown && !ignoreMaintenance) {
    return <Maintenance casino={true} />;
  }
  if (sportsbook && sportsbookShutdown && !ignoreMaintenance) {
    return <Maintenance casino={false} />;
  }

  return <Outlet />;
};

export default MaintenanceWrapper;
